const Radio = ({ onChange, id, checked, name, label }) => {
  return (
    <label
      htmlFor={id}
      className="relative flex items-center gap-2 cursor-pointer select-none"
    >
      <div
        className={`size-4 rounded-full border-2 flex items-center justify-center transition-all`}
        aria-checked={checked}
      >
        <span
          style={{ scale: checked ? "1" : 0 }}
          className="transition-all bg-white rounded-full size-2"
        ></span>
        <input
          onChange={onChange}
          type="radio"
          id={id}
          name={name}
          checked={checked}
          className="absolute opacity-0 cursor-pointer"
        />
      </div>
      {label && <span className="text-sm text-white">{label}</span>}
    </label>
  );
};

export default Radio;
